import React from 'react';
import logo from './assets/images/footer-logo.svg';

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            socialIconStatus: false
        };
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_BASE_URL + "web/" + this.props.PCBID + "/social")
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        socialIconStatus: result.social_icons_active,
                        socialInfo: result.social
                    });
                },
                (error) => {
                    this.setState({
                        socialIconStatus: false,
                        socialInfo: null
                    });
                }
            )
    }

    showSocialMediaIcons = () => {
        if (this.state.socialIconStatus) {
            return (
                <div className="wrap-social-icons">
                    {this.state.socialInfo.map((value) => {
                        return (
                            this.showIcon(value)
                        )
                    })
                    }
                </div>
            )
        }
    }

    showIcon(value) {
        let iconName = 'fab fa-' + value.type
        if (value.type === 'facebook' || value.type === 'pinterest')
            iconName = iconName + '-' + value.type[0]
        if (value && value.active)
            return <a target="_blank" href={value && value.url}><i className={iconName}/></a>
    }

    render() {
        return (
            <footer>
                <div className="content">
                    <div className="three-column">
                        <div className="left-column">
                            <p>
                                <a target="_blank" href="https://petconnectbusiness.com/privacy-policy/">Privacy </a>
                                and
                                <a target="_blank" href="https://petconnectbusiness.com/terms-conditions/"> Terms and
                                    Conditions</a>
                            </p>
                            <p>Powered by <a href='https://petconnectbusiness.com/' target='_blank'><img src={logo}
                                                                                                         alt="Pet Connect"
                                                                                                         title="Pet Connect"/></a>
                            </p>
                        </div>
                        <div className="mid-column">
                            <span>&copy; {new Date().getFullYear() || ''} {this.props.businessName}. All rights reserved.</span>
                        </div>
                        <div className="right-column">
                            {this.showSocialMediaIcons()}
                        </div>
                    </div>
                </div>
            </footer>
        );
    }
}

export default Footer;
